import { getS3FileContent } from "@/pages/api/cache-pages";
import { AWS_STRAPI_JSON_DATA_FOLDER_NAME } from "@/utils/utils";

import axios, { AxiosInstance } from "axios";

export const api: AxiosInstance = axios.create({
  baseURL:
    process.env.ENV_NAME === "development"
      ? process.env.CMS_API_BASE_URL_QA
      : process.env.ENV_NAME === "uat"
      ? process.env.CMS_API_BASE_URL_UAT
      : process.env.CMS_API_BASE_URL_PROD,
});

export const fetchSingleTypeData = async (): Promise<any> => {
  try {
    const response = await api.get(`api/home-page`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching data from home-page:`, error);
    const HomeData = await getS3FileContent(
      `${AWS_STRAPI_JSON_DATA_FOLDER_NAME}/home-page.json`
    );
    return HomeData;
  }
};

export const CmsCoursePages = async (param: string): Promise<any> => {
  try {
    const response = await api.get(
      `api/program-detail-pages?filters[slug][$eq]=${param}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching CMS data:", error);

    const response = await getS3FileContent(
      `${AWS_STRAPI_JSON_DATA_FOLDER_NAME}/program-detail-pages.json`
    );
    return response;
  }
};

export const CmsAllCousesList = async (): Promise<any> => {
  try {
    const response = await api.get(`api/program-detail-pages`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching data from home-page:`, error);
    const response = await getS3FileContent(
      `${AWS_STRAPI_JSON_DATA_FOLDER_NAME}/program-detail-pages.json`
    );
    return response;
  }
};
export const CmsAllSchoolList = async (): Promise<any> => {
  try {
    const response = await api.get(`api/school-pages`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching data from School-page:`, error);
    throw error;
  }
};

export const CmsSchoolPages = async (params: string): Promise<any> => {
  try {
    const response = await api.get(
      `api/school-pages?filters[slug][$eq]=${params}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching CMS data:", error);
    const response = await getS3FileContent(
      `${AWS_STRAPI_JSON_DATA_FOLDER_NAME}/school-pages.json`
    );
    return response;
  }
};
export const CmsEventPages = async (params: string): Promise<any> => {
  try {
    const response = await api.get(
      `api/event-detail-pages?filters[slug][$eq]=${params}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching CMS data:", error);
    return null;
  }
};

export const fetchContactData = async (): Promise<any> => {
  try {
    const response = await api.get(`api/contact-us`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching data from contact-page:`, error);
    const ContactData = await getS3FileContent(
      `${AWS_STRAPI_JSON_DATA_FOLDER_NAME}/contact-us.json`
    );
    return ContactData;
  }
};

export const fetchAboutData = async (): Promise<any> => {
  try {
    const response = await api.get(`api/about-us`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching data from about-page:`, error);
    throw error;
  }
};

export const fetchPolicyData = async (): Promise<any> => {
  try {
    const response = await api.get(`api/privacy-policy`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching data from policy-page:`, error);
    throw error;
  }
};
export const fetchTermsConditionData = async (): Promise<any> => {
  try {
    const response = await api.get(`api/terms-and-condition`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching data from policy-page:`, error);
    throw error;
  }
};

export const fetchAccreditationData = async (): Promise<any> => {
  try {
    const response = await api.get(`api/accreditations-page`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching data from accreditiation-page:`, error);
    const AccreditationsData = await getS3FileContent(
      `${AWS_STRAPI_JSON_DATA_FOLDER_NAME}/accreditations-page.json`
    );
    return AccreditationsData;
  }
};

export const fetchLeadershipPageData = async (): Promise<any> => {
  try {
    const response = await api.get(`api/leadership-page`);
    return response;
  } catch (error) {
    console.error(`Error fetching data from accreditiation-page:`, error);
    throw error;
  }
};

export const fetchSuccessStoryData = async (): Promise<any> => {
  try {
    const response = await api.get(`api/success-story`);
    return response;
  } catch (error) {
    console.error(`Error fetching data from accreditiation-page:`, error);
    const LeadershipData = await getS3FileContent(
      `${AWS_STRAPI_JSON_DATA_FOLDER_NAME}/leadership-page.json`
    );
    return LeadershipData;
  }
};

export const CmsUgpgPages = async (params: string): Promise<any> => {
  try {
    const response = await api.get(`api/ug-pgs?filters[slug][$eq]=${params}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching CMS data:", error);
    const response = await getS3FileContent(
      `${AWS_STRAPI_JSON_DATA_FOLDER_NAME}/ug-pgs.json`
    );
    return response;
  }
};

export const fetchAboutUsData = async (): Promise<any> => {
  try {
    const response = await api.get(`api/about-us`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching data from home-page:`, error);
    throw error;
  }
};
export const fetchEventsData = async (): Promise<any> => {
  try {
    const response = await api.get(`api/event`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching data from home-page:`, error);
    throw error;
  }
};

export const fetchAllProgramPageData = async (): Promise<any> => {
  try {
    const response = await api.get(`api/all-programs-page
`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching data from home-page:`, error);
    const AllAcademicData = await getS3FileContent(
      `${AWS_STRAPI_JSON_DATA_FOLDER_NAME}/all-programs-page.json`
    );
    return AllAcademicData;
  }
};

export const fetchSchoolFundingData = async (): Promise<any> => {
  try {
    const response = await api.get(`api/student-funding-option`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching data from home-page:`, error);
    const StudentLoandData = await getS3FileContent(
      `${AWS_STRAPI_JSON_DATA_FOLDER_NAME}/student-funding-option.json`
    );
    return StudentLoandData;
  }
};
export const fetchAlumnipPageData = async (): Promise<any> => {
  try {
    const response = await api.get(`api/alumni-page`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching data from alumni-page:`, error);
    const AlumniData = await getS3FileContent(
      `${AWS_STRAPI_JSON_DATA_FOLDER_NAME}/alumni-page.json`
    );
    return AlumniData;
  }
};
export const fetchAllProgramNamesList = async (): Promise<any> => {
  try {
    const response = await api.get(`api/program-of-interest`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching data from home-page:`, error);
    throw error;
  }
};

// GET: Check if alumni user exists by phone number or email
export const checkAlumniUserExists = async (
  phoneNumber: string,
  email: string
): Promise<any> => {
  try {
    const response = await api.get(
      `api/alumni-user-informations?filters[$or][0][phone_number][$eq]=${encodeURIComponent(
        phoneNumber
      )}&filters[$or][1][email][$eq]=${encodeURIComponent(email)}`
    );
    return response.data;
  } catch (error) {
    console.error("Error checking alumni user existence:", error);
    throw error;
  }
};

// POST: Register a new alumni user
export const registerAlumniUser = async (alumniPayload: any): Promise<any> => {
  try {
    // Format the payload according to Strapi's requirements
    const formattedPayload = {
      data: {
        full_name: alumniPayload.full_name,
        email: alumniPayload.email,
        student_number: alumniPayload.student_number,
        most_recent_qualification: alumniPayload.most_recent_qualification,
        current_occupation: alumniPayload.current_occupation,
        company_name: alumniPayload.company_name,
        phone_number: alumniPayload.phone_number,
        graduation_year: alumniPayload.graduation_year,
        date_of_birth: alumniPayload.date_of_birth,
      },
    };

    const response = await api.post(
      "api/alumni-user-informations",
      formattedPayload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error registering alumni user:", error);
    if (axios.isAxiosError(error)) {
      console.error("API Error Response:", error.response?.data);
    }
    throw error;
  }
};

export const fetchCommunityEngagementsData = async (): Promise<any> => {
  try {
    const response = await api.get(`api/community-engagement`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching data from home-page:`, error);
    throw error;
  }
};

export const fetchFacultyPageData = async (): Promise<any> => {
  try {
    const response = await api.get(`api/faculty-and-insight`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching data from faculty-page:`, error);
    throw error;
  }
};
export const fetchCareerPageData = async (): Promise<any> => {
  try {
    const response = await api.get(`api/career-page`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching data from career-page:`, error);
    throw error;
  }
};
export const fetchJobData = async (): Promise<any> => {
  try {
    const response = await api.get(`api/job-data`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching data from job-data:`, error);
    throw error;
  }
};
export const CmsCarrerDetailPage = async (params: string): Promise<any> => {
  try {
    const response = await api.get(
      `api/career-detail-pages?filters[slug][$eq]=${params}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching CMS data:", error);
    return null;
  }
};
export const CmsCarrerDetailAllPageData = async (): Promise<any> => {
  try {
    const response = await api.get(`api/career-detail-pages`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching data from career-detail-pages:`, error);
    throw error;
  }
};

export const postEventUserData = async (formData: any): Promise<any> => {
  try {
    const response = await api.post("/api/event-user-datas", {
      data: {
        name: formData?.name || "",
        phone_number: formData?.mobileNumber || "",
        email: formData?.email || "",
        program_of_interest: formData?.course || null,
        highest_qualification: formData?.qualification || null,
        study_mode: formData?.mode || null,
        event_name: formData?.event_name || "Default Event",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error posting event user data:", error);
    throw error;
  }
};

export const postCareerUserData = async (formData: any): Promise<any> => {
  try {
    const response = await api.post("/api/career-user-datas", {
      data: {
        name: formData.name,
        email: formData.email,
        phone_number: formData.phoneNumber,
        resume_url: formData.resumeUrl,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error posting career user data:", error);
    throw error;
  }
};

export const CmsLPCoursePages = async (param: string): Promise<any> => {
  try {
    const response = await axios.get(
      `${process.env.CMS_API_BASE_URL_LP}/api/landing-pages?filters[slug][$eq]=${param}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching CMS data:", error);
    return null;
  }
};

export default api;
